import { ComponentType } from 'react';

import type PageComponent from '@rover/types/src/PageComponent';

function withBackHistoryHeader<HOCProps extends object>(
  Component: PageComponent<HOCProps>
): ComponentType<HOCProps> {
  const ComponentWrapper = (props: HOCProps): JSX.Element => <Component {...props} />;

  ComponentWrapper.shouldSetBackHistoryHeader = true;

  return ComponentWrapper;
}

export default withBackHistoryHeader;
